module.exports = __webpack_public_path__ + "img/RG_verso.62270d40.svg";